import { WaitingListStatus } from '@flyblack/common/domains';

import { authorizedApi } from '@/services/network/authorized-api';

export const getWaitingListStatus = () => authorizedApi.get<{ status: WaitingListStatus }>(`/v1/waiting-list/status`);

export const setWaitingListStatus = (status: WaitingListStatus) =>
  authorizedApi.put(`/v1/waiting-list/${status === WaitingListStatus.Enabled ? 'enable' : 'disable'}`);
